"use strict";
exports.__esModule = true;
exports.VendorCheckboxFacet = void 0;
var decorators_1 = require("./../decorators");
var logic_1 = require("./../logic");
exports.VendorCheckboxFacet = decorators_1.decorateCheckboxFacet(logic_1.VendorFacet);
//# sourceMappingURL=VendorFacets.js.map